import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import MainNav from '../components/MainNav';

export default function Terms() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <MainNav />
      
      <main className="pt-24 pb-12 px-4 lg:px-8">
        <div className="max-w-3xl mx-auto">
          {/* Header */}
          <div className="flex items-center gap-4 mb-8">
            <Button
              variant="ghost"
              onClick={() => navigate(-1)}
              className="text-zinc-400 hover:text-white"
            >
              <ArrowLeft className="h-5 w-5" />
            </Button>
            <h1 className="text-2xl font-bold text-white">Terms of Service</h1>
          </div>

          <div className="glass-card p-8 prose prose-invert max-w-none">
            <p className="text-zinc-400 text-sm mb-6">Last updated: March 2026</p>
            
            <h2 className="text-xl font-semibold text-white mt-6 mb-4">1. Acceptance of Terms</h2>
            <p className="text-zinc-300 mb-4">
              By accessing and using Wrapped In Music ("the Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our service.
            </p>

            <h2 className="text-xl font-semibold text-white mt-6 mb-4">2. Description of Service</h2>
            <p className="text-zinc-300 mb-4">
              Wrapped In Music provides AI-powered music creation tools including lyric generation, song generation, and album cover creation. The service operates on a credit-based system.
            </p>

            <h2 className="text-xl font-semibold text-white mt-6 mb-4">3. User Accounts</h2>
            <p className="text-zinc-300 mb-4">
              You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You must provide accurate information when creating an account.
            </p>

            <h2 className="text-xl font-semibold text-white mt-6 mb-4">4. Credits and Payments</h2>
            <p className="text-zinc-300 mb-4">
              Credits are used to access various features of the service. Purchased credits are non-refundable except where required by law. We reserve the right to modify pricing at any time.
            </p>

            <h2 className="text-xl font-semibold text-white mt-6 mb-4">5. Content Ownership</h2>
            <p className="text-zinc-300 mb-4">
              You retain ownership of the content you create using our service, including lyrics, songs, and album covers. By using our service, you grant us a license to store and process your content as necessary to provide the service.
            </p>

            <h2 className="text-xl font-semibold text-white mt-6 mb-4">6. Acceptable Use</h2>
            <p className="text-zinc-300 mb-4">
              You agree not to use the service to create content that is illegal, harmful, threatening, abusive, harassing, defamatory, or otherwise objectionable. We reserve the right to remove content and suspend accounts that violate these terms.
            </p>

            <h2 className="text-xl font-semibold text-white mt-6 mb-4">7. AI-Generated Content</h2>
            <p className="text-zinc-300 mb-4">
              Our service uses artificial intelligence to generate content. While we strive for quality, we cannot guarantee that AI-generated content will meet all expectations or be free from errors.
            </p>

            <h2 className="text-xl font-semibold text-white mt-6 mb-4">8. Limitation of Liability</h2>
            <p className="text-zinc-300 mb-4">
              The service is provided "as is" without warranties of any kind. We shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the service.
            </p>

            <h2 className="text-xl font-semibold text-white mt-6 mb-4">9. Changes to Terms</h2>
            <p className="text-zinc-300 mb-4">
              We may modify these terms at any time. Continued use of the service after changes constitutes acceptance of the modified terms.
            </p>

            <h2 className="text-xl font-semibold text-white mt-6 mb-4">10. Contact</h2>
            <p className="text-zinc-300 mb-4">
              For questions about these terms, please contact us at{' '}
              <a href="mailto:support@wrappedinmusic.com" className="text-primary hover:underline">
                support@wrappedinmusic.com
              </a>
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
